import React, { useState } from "react"
import LeftSideTabs from "./LeftSideTabs"
import Legend from "./Legend"
import LeftSizeResourceList from "./LeftSizeResourceList"
import LeftSideCards from "./LeftSideCards"
import CustomProgressBar from "src/components/custom-progress-bar"
import { IconButton, Menu, MenuItem } from "@material-ui/core"
import { moreIcon, printIcon, refreshIcon } from "src/components/icons-svg"
import Disclaimer from "src/components/disclaimer"
/**
 * @param props {{
 *  scState:scState
 * }}
 */
export default function AnalyzerResources({ scState }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMoreOptions = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return <div css="min-height:100%;padding:22px 20px;background-color:#f6f6fa">
    <div css={`display:flex;align-items:center;`}>
      <div css={`font-weight:bold;font-size:30px;`}>Resources</div>
      <div css={`flex:1;`}></div>
      <Legend scState={scState} />
    </div>
    <Disclaimer/>
    <br />
    <div>
      <CustomProgressBar
        showPercentage={false}
        progress={Math.floor(
          // @ts-ignore
          scState.getTotalProgress().total === 0 ? 0 : (scState.getTotalProgress().completed / scState.getTotalProgress().total * 100))} />
      <br />
      <div css={`display:flex;align-items:center; justify-content: space-between;`}>
        <div>
          Completed {scState.getTotalProgress().completed}/{scState.getTotalProgress().total} review tasks
        </div>
        <div css={`display:flex;align-items:center;`}>
          <div css={`cursor:pointer;color:blue;text-decoration:underline; padding-right: 12px;`} onClick={() => scState.showEditReviewFileModal()}>
            Edit review files
          </div>
          <div css={`cursor:pointer;color:blue;text-decoration:underline;`} onClick={() => scState.onDefineDefaultStepClick()}>
            Edit initialization steps
          </div>
          <div>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          {moreIcon}
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={openMoreOptions}
          onClose={handleClose}
        >
          <MenuItem key={1} onClick={() => {scState.reAnalyze(); handleClose();}}>
            {refreshIcon()}&nbsp;Re-analyze
          </MenuItem>
          <MenuItem key={1} onClick={() => {scState.print(); handleClose();}}>
            {printIcon()}&nbsp;Print Report
          </MenuItem>
        </Menu>
      </div>
        </div>
      </div>
    </div>

    <LeftSideTabs scState={scState} />

    {scState.selectedResourseType && <LeftSizeResourceList
      scState={scState}
    />}
    <LeftSideCards scState={scState}/>
  </div>
}